import React, { Component, Fragment } from 'react';
import b from 'b_';

import './outreach.css';

import EventItem from '@components/event-item';
import ProjectItem from '@components/project-item';
import DatasetItem from '@components/dataset-item';
import { Dataset, Project, Event } from '@interfaces/outreach-entity';
import PageMeta from '@components/page-meta';
import { AsyncFetchDataProps } from '@interfaces/async-fetch-data';
import { fetchOutreachPage } from 'client/ducks/outreach/actions';
import EntitiesBlock from '@components/entities-block';

import OutreachPageStub from './outreach.stub';
import pageConfig from './page-config.json';

export interface DispatchProps {
    fetchOutreachPage(): void;
}

export interface StateProps {
    events: Event[];
    projects: Project[];
    datasets: Dataset[];
    isLoading: boolean;
}

type Props = StateProps & DispatchProps & {};

const class_ = b.with('outreach');

export default class OutreachPage extends Component<Props> {
    public static asyncFetchData({ dispatch }: AsyncFetchDataProps) {
        dispatch(fetchOutreachPage());
    }

    public componentDidMount() {
        const { events } = this.props;
        if (!events.length) {
            this.props.fetchOutreachPage();
        }
    }

    public shouldComponentUpdate() {
        return true;
    }

    public renderDataset = (dataset: Dataset) => {
        return (
            <DatasetItem
                type="vertical"
                key={dataset.id}
                entity={dataset}
            />
        );
    };

    public renderProject = (project: Project) => {
        return (
            <ProjectItem
                type="vertical"
                key={project.id}
                entity={project}
            />
        );
    };

    public renderEvent = (event: Event) => {
        return (
            <EventItem
                type="vertical"
                key={event.id}
                entity={event}
            />
        );
    };

    public renderOutreachEntities() {
        const { events, projects, datasets } = this.props;

        return (
            <Fragment>
                {Boolean(events.length) && (
                    <EntitiesBlock
                        title="Recent Events"
                        linkToAllEntities={{ text: 'All Events', url: '/outreach/events' }}
                        entities={events}
                        renderItem={this.renderEvent}
                    />
                )}
                {Boolean(projects.length) && (
                    <EntitiesBlock
                        title="Our Open source projects"
                        linkToAllEntities={{ text: 'All Open source projects', url: '/outreach/projects' }}
                        entities={projects}
                        renderItem={this.renderProject}
                    />
                )}
                {Boolean(datasets.length) && (
                    <EntitiesBlock
                        title="Datasets"
                        linkToAllEntities={{ text: 'All Datasets', url: '/outreach/datasets' }}
                        entities={datasets}
                        renderItem={this.renderDataset}
                    />
                )}
            </Fragment>
        );
    }

    public render() {
        const { description, meta } = pageConfig;
        const { isLoading } = this.props;

        return (
            <div className={class_()}>
                <PageMeta title={meta.title} description={meta.description} />

                <h1 className="block__title">Outreach</h1>
                <div className={class_('description')}>
                    {description}
                </div>

                {isLoading
                    ? <OutreachPageStub />
                    : this.renderOutreachEntities()
                }
            </div>
        );
    }
}
